import { useState } from "react";
import { UsuarioInterface } from "../../../Interfaces/Geral/GestaoUsuarios/UsuariosInterface";
import {
    AtualizarUsuarioController,
    DeletarUsuarioController,
} from "../../../Controllers/Geral/GestaoUsuarios/UsuariosController";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Swal from "sweetalert2";
import { faEdit, faPlus, faTrash } from "@fortawesome/free-solid-svg-icons";
import Table from "../../../Components/Table";
import ModalComponent from "../../../Components/Modais";
import { IComponentModal } from "../../../Components/Modais/IModalComponent";
import EditarUsuario, { EditarUsuarioHeader } from "./EditarUsuario";
import CadastrarUsuario from "./CadastrarUsuario";
import useAsyncEffect from "../../../hooks/useAsyncEffect";
import { useUserInfor } from "../../../Context/User";
import { Tab, Tabs } from "react-bootstrap";
import { ListarUsuariosOrganizacaoController } from "../../../Controllers/Users/UsersController";

function Usuarios() {
    const [show, setShow] = useState(false);
    const [modal, setModal] = useState<IComponentModal>();
    const {
        value: lstUsuarios,
        loading: lstUsuariosLoading,
        execute: updateList,
    } = useAsyncEffect(async () => {
        return ListarUsuariosOrganizacaoController(false);
    });

    const { ID_USUARIO } = useUserInfor().UserInfor;

    const lstUsariosAtivos = lstUsuarios?.USUARIOS_ATIVOS;
    const lstUsariosInativos = lstUsuarios?.USUARIOS_INATIVOS;
    const lstUsariosNaoValidados = lstUsuarios?.USUARIOS_PARA_CONFIRMACAO;

    function RowTable(cell: any, row: UsuarioInterface) {
        return (
            <>
                <div className="rowCapys">
                    <div>
                        <h4>{row.DS_NOME}</h4>
                        <div className="StatusUser">
                            {row.FL_ATIVO ? (
                                <span className="label abel-pill label-inline label-success mr-2">
                                    Ativado
                                </span>
                            ) : (
                                <span className="label label-danger abel-pill label-inline mr-2">
                                    Desativado
                                </span>
                            )}

                            {row.FL_ADMINISTRADOR ? (
                                <span className="label abel-pill label-inline label-success mr-2">
                                    Administrador
                                </span>
                            ) : null}
                        </div>
                    </div>
                    <div className="col-tools">
                        <div className="toolsTable">
                            <label className="text-white">Capys Tools</label>
                            <div className="tools-capys">
                                <OverlayTrigger
                                    overlay={
                                        <Tooltip id="tooltip-disabled">
                                            {row.FL_ATIVO
                                                ? "Desativar Usuário"
                                                : "Ativar Usuário"}
                                        </Tooltip>
                                    }
                                >
                                    <span
                                        className="switch switch-outline switch-sm switch-icon switch-success"
                                        data-toggle="tooltip"
                                    >
                                        <label>
                                            <input
                                                id="FL_ATIVO_STATUS"
                                                name="fL_ATIVO"
                                                checked={row.FL_ATIVO}
                                                disabled={
                                                    ID_USUARIO &&
                                                    ID_USUARIO === 8273
                                                        ? false
                                                        : row.ID_USUARIO ===
                                                          8273
                                                }
                                                type="checkbox"
                                                onChange={() => {
                                                    row.FL_ATIVO =
                                                        !row.FL_ATIVO;
                                                    AtualizarUsuarioController(
                                                        row,
                                                        0
                                                    ).then((response) => {
                                                        //força o update da célula da tabela
                                                        row.DS_NOME += " ";
                                                        updateList();
                                                    });
                                                }}
                                            />
                                            <span></span>
                                        </label>
                                    </span>
                                </OverlayTrigger>
                                <OverlayTrigger
                                    overlay={
                                        <Tooltip id="tooltip-disabled">
                                            {row.FL_ADMINISTRADOR
                                                ? "Remover Administrador"
                                                : "Tornar Administrador"}
                                        </Tooltip>
                                    }
                                >
                                    <span
                                        className="switch switch-outline switch-sm switch-icon switch-info"
                                        data-toggle="tooltip"
                                    >
                                        <label>
                                            <input
                                                id="fL_ANALISAR_CREDITO_STATUS"
                                                name="fL_ANALISAR_CREDITO"
                                                checked={row.FL_ADMINISTRADOR}
                                                disabled={
                                                    ID_USUARIO &&
                                                    ID_USUARIO === 8273
                                                        ? false
                                                        : row.ID_USUARIO ===
                                                          8273
                                                }
                                                type="checkbox"
                                                onChange={() => {
                                                    row.FL_ADMINISTRADOR =
                                                        !row.FL_ADMINISTRADOR;
                                                    AtualizarUsuarioController(
                                                        row,
                                                        0
                                                    ).then((response) => {
                                                        //força o update da célula da tabela
                                                        row.DS_NOME += " ";
                                                        updateList();
                                                    });
                                                }}
                                            />
                                            <span></span>
                                        </label>
                                    </span>
                                </OverlayTrigger>
                            </div>
                        </div>
                        <div className="Button-Tools">
                            <button
                                className="btn btn-outline-primary font-weight-bold mr-2"
                                onClick={() => {
                                    setShow(true);
                                    setModal({
                                        Component: () =>
                                            EditarUsuario({
                                                USER: row,
                                                updateList,
                                                setShow,
                                            }),
                                        customHeader: EditarUsuarioHeader(
                                            row.DS_NOME
                                        ),
                                        size: "lg",
                                    });
                                }}
                                disabled={
                                    ID_USUARIO && ID_USUARIO === 8273
                                        ? false
                                        : row.ID_USUARIO === 8273
                                }
                            >
                                <FontAwesomeIcon icon={faEdit} size="lg" />{" "}
                                Editar
                            </button>
                            <button
                                className="btn btn-outline-danger font-weight-bold mr-2"
                                onClick={() => {
                                    Swal.fire({
                                        title: "Deseja apagar este usuário?",
                                        icon: "info",
                                        buttonsStyling: false,
                                        confirmButtonText:
                                            "<i class='la la-check'></i> Sim!",
                                        showCancelButton: true,
                                        cancelButtonText:
                                            "<i class='la la-thumbs-down'></i> Não",
                                        customClass: {
                                            confirmButton:
                                                "btn btn-outline-success",
                                            cancelButton: "btn btn-default",
                                        },
                                    }).then((result) => {
                                        if (result.isConfirmed) {
                                            DeletarUsuarioController(
                                                row.ID_USUARIO
                                            ).then((response) => {
                                                updateList();
                                            });
                                        }
                                    });
                                }}
                                disabled={
                                    ID_USUARIO && ID_USUARIO === 8273
                                        ? false
                                        : row.ID_USUARIO === 8273
                                }
                            >
                                <FontAwesomeIcon icon={faTrash} size="lg" />{" "}
                                Excluir
                            </button>
                        </div>
                    </div>
                </div>
            </>
        );
    }

    const ColunsUser = [
        {
            dataField: "DS_NOME",
            text: "Nome",
            formatter: RowTable,
            sort: true,
        },
    ];

    return (
        <>
            <div className="card card-custom" id="kt_page_sticky_card">
                <div className="card-header border-0 pt-5">
                    <h3 className="card-title align-items-start flex-column">
                        <span className="card-label font-weight-bolder text-dark gruposTitle">
                            Gestão de Usuários
                        </span>
                    </h3>
                    <div className="card-toolbar">
                        <button
                            className="btn btn-success font-weight-bold mr-2"
                            onClick={() => {
                                setShow(true);
                                setModal({
                                    Component: () =>
                                        CadastrarUsuario({
                                            setShow,
                                            updateList,
                                        }),
                                    noHeader: true,
                                    noFooter: true,
                                    size: "lg",
                                });
                            }}
                        >
                            <FontAwesomeIcon
                                icon={faPlus}
                                size="lg"
                                className="mr-2"
                            />{" "}
                            Novo Usuário
                        </button>
                    </div>
                </div>
                <div className="card-body pt-2 pb-0 mt-n3">
                    <Tabs defaultActiveKey="ativos">
                        <Tab title="Usuários ativos" eventKey="ativos">
                            <div className="table-responsive-sm">
                                <Table
                                    keyField="ID_USUARIO"
                                    data={lstUsariosAtivos ?? []}
                                    columns={ColunsUser}
                                    loading={lstUsuariosLoading}
                                />
                            </div>
                        </Tab>
                        <Tab title="Usuários Inativos" eventKey="inativos">
                            <div className="table-responsive-sm">
                                <Table
                                    keyField="ID_USUARIO"
                                    data={lstUsariosInativos ?? []}
                                    columns={ColunsUser}
                                    loading={lstUsuariosLoading}
                                />
                            </div>
                        </Tab>
                        <Tab
                            title="Usuários Não validados"
                            eventKey="invalidados"
                        >
                            <div className="table-responsive-sm">
                                <Table
                                    keyField="ID_USUARIO"
                                    data={lstUsariosNaoValidados ?? []}
                                    columns={ColunsUser}
                                    loading={lstUsuariosLoading}
                                />
                            </div>
                        </Tab>
                    </Tabs>
                </div>
            </div>

            <ModalComponent
                show={show}
                setShow={setShow}
                ModalComponent={modal}
            />
        </>
    );
}

export default Usuarios;
